import UserBrands from "./UserBrands-container";

/**
 * Export the top level component UserBrands-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default UserBrands;
